var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-liveview__map"},[_c('VideoList',{ref:"videoList"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }